// gioco/rotazione.ts — filtri che cambiano da soli durante il gioco (impostazione app.filtri_rotazione_secondi).
// Il momento del cambio si calcola dal tempo GIOCATO della partita (deciso dal server, uguale sui due telefoni e
// fermo durante pause e accuse): i due giocatori cambiano faccia nello stesso istante.
// Ognuno pesca tra i filtri che può usare (piano, crediti). Puro: si prova con node:test.

export interface MomentoRotazione {
  /** Quanti cambi ci sono già stati in questo round (0 = filtro iniziale). */
  indice: number;
  /** Secondi al prossimo cambio da mostrare (3, 2, 1), oppure null fuori dall'avviso. */
  avviso: number | null;
}

export function momentoRotazione(tempoGiocatoMs: number, periodoS: number, avvisoS: number): MomentoRotazione {
  if (!(periodoS > 0) || !(tempoGiocatoMs >= 0)) return { indice: 0, avviso: null };
  const periodo = periodoS * 1000;
  const indice = Math.floor(tempoGiocatoMs / periodo);
  const manca = periodo - (tempoGiocatoMs % periodo);
  const avviso = avvisoS > 0 && manca <= avvisoS * 1000 ? Math.ceil(manca / 1000) : null;
  return { indice, avviso };
}

/** Il prossimo filtro: a caso tra quelli usabili, diverso da quello attuale quando ce n'è più di uno. */
export function prossimoFiltro(usabili: readonly string[], attuale: string | null, casuale: () => number): string | null {
  const scelta = usabili.length > 1 ? usabili.filter((id) => id !== attuale) : usabili;
  if (!scelta.length) return null;
  return scelta[Math.min(scelta.length - 1, Math.floor(casuale() * scelta.length))]!;
}
